import { render, staticRenderFns } from "./GuiasLancadas.vue?vue&type=template&id=13268f6c&scoped=true&"
import script from "./GuiasLancadas.vue?vue&type=script&lang=js&"
export * from "./GuiasLancadas.vue?vue&type=script&lang=js&"
import style0 from "./GuiasLancadas.vue?vue&type=style&index=0&id=13268f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13268f6c",
  null
  
)

export default component.exports